// What a list (grid) shows: the columns of the view that's open - nothing more. The one column
// every view of a record list always has is the record's name, so a row can be told apart and
// opened; the other fields the create form requires (a site's Site Group, Customer, Status...)
// are ordinary columns a view can have or not.
// Lists with fixed columns (Attendance Gap, Tasks) build their own column list, marked read-only
// and without a form propertyId - those all stay.
const NAME_FIELDS = new Set([
  "firstname", "lastname", "sitename", "branchname", "customername", "sitegroupname", "suppliername", "agencyname",
]);

const keyOf = (label) => String(label ?? "").replace(/\s/g, "").toLowerCase();

export const isNameField = (field) => NAME_FIELDS.has(keyOf(field?.propertyDetail?.label ?? field?.label));

// a column every view of this list shows (and Edit Columns can't take off)
export const isAlwaysShownColumn = (field) => !!field?.isReadOnly && (!field?.propertyId || isNameField(field));
